import React from 'react'

import { useAuthenticatedUser } from '@/state/session'
import { BaseProfile } from '@/types/user'

export enum ROLES {
  TECHNICIAN = 'technician',
  PRACTICIAN = 'practician',
}

export const useAuthorization = () => {
  const user = useAuthenticatedUser()

  const checkAccess = React.useCallback(
    ({ allowedRoles }: { allowedRoles: BaseProfile[] }) => {
      if (allowedRoles && allowedRoles.length > 0 && user.profile.profile) {
        return allowedRoles?.includes(user.profile.profile as BaseProfile)
      }

      return true
    },
    [user.profile.profile],
  )

  return { checkAccess, role: user.profile.profile as BaseProfile }
}

type AuthorizationProps = React.PropsWithChildren<{
  forbiddenFallback?: React.ReactNode
  allowedRoles: BaseProfile[]
}>

export const Authorization = ({ allowedRoles, forbiddenFallback = null, children }: AuthorizationProps) => {
  const { checkAccess } = useAuthorization()

  let canAccess = false

  if (allowedRoles) {
    canAccess = checkAccess({ allowedRoles })
  }

  return <>{canAccess ? children : forbiddenFallback}</>
}
